import { render, staticRenderFns } from "./FormControlContentClass.vue?vue&type=template&id=12421cc8"
import script from "./FormControlContentClass.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlContentClass.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports